import { sendSoapRequest, createSoapEnvelope } from "./soapClient.js";

const modifyUsers = async (profileData, username, password, setProgress) => {
  try {
    const userXMLBody = `
      <ser:modifyUser>
         <!--Optional:-->
         <userGeneralInfo>
            <userName>${profileData.username}</userName>
            <federationId>${profileData.fedid}</federationId>
         </userGeneralInfo>
      </ser:modifyUser>
      `;

    const soapBody = createSoapEnvelope(userXMLBody);

    try {
      // Send the SOAP request
      console.log("User request body:", soapBody);
      const result = await sendSoapRequest(
        "modifyUser",
        soapBody,
        username,
        password
      );
      console.log(
        `User ${profileData.username} modified successfully:`,
        result
      );
      setProgress((prev) => [
        ...prev,
        `User modified successfully: ${profileData.username}`,
      ]); // Update progress here
      return;
    } catch (error) {
      console.error(`Error modifying user ${profileData.username}:`, error);
      setProgress((prev) => [
        ...prev,
        `Error creating User ${profileData.username}: ${error.message}`,
      ]);
      throw error; // Re-throw the error for further handling if needed
    }
  } catch (error) {
    console.error("Error creating user:", error);
  }
};

export default modifyUsers;
